.list {
  display: grid;
  gap: 56px;
}

.row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
}

.reverse {
  direction: rtl;
}

.reverse > * {
  direction: ltr;
}

.text {
  max-width: 480px;
}

.blockTitle {
  margin-bottom: 14px;
  font-size: 24px;
  font-weight: 700;
}

.blockDesc {
  margin-bottom: 16px;
  font-size: 15px;
  line-height: 1.65;
  color: var(--color-text-muted);
}

.tags {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--color-gold);
}

@media (max-width: 800px) {
  .row,
  .reverse {
    grid-template-columns: 1fr;
    direction: ltr;
  }
}
